import React, { useState } from "react";
import "./Navigation.css";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';


function Navigation(props){

  const [bgColor, setBgColor]=useState("#4e54c8");
  const [scrollColor, setScrollColor]=useState("#48abe0");

  function setDefault(){
    setBgColor("#4e54c8");
    setScrollColor("#48abe0");
    props.setimg("default");
  }

  function setBlue(){
    setBgColor("#001c30");
    setScrollColor("#176b87");
    props.setimg("blue");
  }
  
  function setGreen(){
    setBgColor("#17594a");
    setScrollColor("#539165");
    props.setimg("green");
  }

  document.documentElement.style.setProperty('--bg-color', bgColor);
  document.documentElement.style.setProperty('--scroll-color', scrollColor);

    return (
      <div className="nav-bar">
      <Container style={{padding: "0 7%"}}>
      <Navbar collapseOnSelect expand="lg" className="" data-bs-theme="dark">
        <Navbar.Brand href="#home"><h1 className="nav-title">Portfolio.</h1></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
          </Nav>
          <Nav>
            <Nav.Item className="color-button-box">
              <button className="color-button default-color" onClick={setDefault}></button>
              <button className="color-button blue-color" onClick={setBlue}></button>
              <button className="color-button green-color" onClick={setGreen}></button>
            </Nav.Item>
            <Nav.Link href="#tech"><p className="navbar-item">Technologies</p></Nav.Link>
            <Nav.Link href="#projects"><p className="navbar-item">Projects</p></Nav.Link>
            <Nav.Link href="#contact"><p className="navbar-item">Contact</p></Nav.Link>
            
          </Nav>
        </Navbar.Collapse>
    </Navbar>
      </Container>
    </div>
    );
}

export default Navigation;